import React, { memo } from 'react';

import ContTitle from '@wconcept/wconcept-ui-renewal/components/molecules/_title/ContTitle';
import Box from '@wconcept/wconcept-ui-renewal/components/atoms/Box';
import ItemsScrollBar from '@wconcept/wconcept-ui-renewal/components/atoms/ItemsScrollBar';

import * as S from './style';

interface IProps {
  title?: string;
  subTitle?: string;
  isAd?: boolean;
  menuBar?: React.ReactNode;
  scrollInit?: boolean;
  bgColor?: boolean;
  children?: React.ReactNode;
  scrollContainerRef?: React.RefObject<HTMLDivElement | null>;
  onTouchStart?: (e: React.UIEvent<HTMLDivElement>) => void;
  onTouchEnd?: (e: React.UIEvent<HTMLDivElement>) => void;
  onScroll?: (e: React.UIEvent<HTMLDivElement>) => void;
}

const RecProductList = ({
  title = '이런 상품 어떠세요?',
  subTitle,
  isAd = false,
  menuBar,
  scrollInit = false,
  bgColor = false,
  children,
  scrollContainerRef,
  onTouchStart,
  onTouchEnd,
  onScroll,
}: IProps) => (
  <S.RecProductList className={`reco-product-list ${bgColor ? 'bg-type' : ''}`}>
    <ContTitle title={title} title2={subTitle} isAd={isAd} />
    {menuBar && <Box pb={16}>{menuBar}</Box>}
    <ItemsScrollBar
      ref={scrollContainerRef}
      perView={3.173}
      colGap={6}
      offsetLR={16}
      scrollInit={scrollInit}
      onScroll={onScroll}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      {children}
    </ItemsScrollBar>
  </S.RecProductList>
);

export default memo(RecProductList);
